module.exports = __webpack_public_path__ + "img/LV2.f26bf48a.svg";